/**
 * DWT dependencies
 */

import { filterOutWhiteSpace } from '../utils/general-utils';

/**
 * WP dependencies
 */

import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';

const save = () => {
  const blockProps = useBlockProps.save({
    className: `block__list-with-filters mt-25 mb-60`
  });

  const innerBlocksClasses = filterOutWhiteSpace( [
    'inner-blocks-wrapper'
  ] );

  const { children, ...innerBlocksProps } = useInnerBlocksProps.save({
    className: innerBlocksClasses
  });

  return (
    <div { ...blockProps }>
      <div className='list-with-filters--inner'>
        <div { ...innerBlocksProps }>
          { children }
        </div>
      </div>
    </div>
  );
};

export default save;
